import { pdpAvailableRecommendationGetRequestParams } from '../../../experiments/experiment-pdp-available/pdpAvailableRecommendationGetRequestParams'
import { useGetExperiment } from '../../../experiments/hooks'
import {
  EXPERIMENT_NAME_PDP_AVAILABLE,
  EXPERIMENT_NAME_PDP_AVAILABLE_RECOMMENDATION_SERVICE,
} from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import { useGlobalConfigContext } from '../../../global-config'
import {
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE,
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V1,
  RECOMMENDATION_WIDGET_PDP_AVAILABLE,
  RECOMMENDATION_WIDGET_PDP_OUT_OF_STOCK,
  type RecommendationServiceType,
  type RecommendationWidgetType,
} from '../../../recommendation'
import { productAccessorGetRecommendationServiceId } from '../../model/productAccessor/productAccessorGetRecommendationServiceId'
import { productAccessorStockStatusIsAvailable } from '../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { PRODUCT_TEMPLATES } from '../../model/productTemplates'
import { useProductPageContext } from '../productPageContext'

type RecommendationWidgetHorizontalSliderRequestParams = {
  baseServiceId: RecommendationServiceType
  pid: string
  prodrec?: true
  sellerid: string
  serviceId: RecommendationServiceType
  titlekey?: string
  widgetId: RecommendationWidgetType
}

export const useProductAvailableRecommendationWidgetSliderRequestParams =
  (): RecommendationWidgetHorizontalSliderRequestParams => {
    const { currentOffer, currentVariant, productTemplate } =
      useProductPageContext()
    const { language } = useGlobalConfigContext()
    const isAvailable = productAccessorStockStatusIsAvailable(currentVariant)
    const recommendationServiceExperiment = useGetExperiment(
      EXPERIMENT_NAME_PDP_AVAILABLE_RECOMMENDATION_SERVICE,
    )
    const pdpAvailableExperiment = useGetExperiment(
      EXPERIMENT_NAME_PDP_AVAILABLE,
    )
    const isProdrecEnabledAndV2 =
      pdpAvailableExperiment.isEnabled &&
      pdpAvailableExperiment.variant === EXPERIMENT_VARIATION.V2

    // we are rendering out of stock area in ProductAvailableRecommendationSliderArea position
    // if product has other variants available but the selected one is out of stock
    // so we need to set widgetId and serviceId accordingly
    const baseServiceId = productAccessorGetRecommendationServiceId({
      isAvailable,
      isRx: productTemplate === PRODUCT_TEMPLATES.RX,
    })
    const widgetId =
      baseServiceId === RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE
        ? RECOMMENDATION_WIDGET_PDP_AVAILABLE
        : RECOMMENDATION_WIDGET_PDP_OUT_OF_STOCK
    const currentServiceId =
      widgetId === RECOMMENDATION_WIDGET_PDP_AVAILABLE &&
      recommendationServiceExperiment.isEnabled &&
      recommendationServiceExperiment.variant === EXPERIMENT_VARIATION.V1
        ? RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V1
        : baseServiceId

    const experimentRequestParams = pdpAvailableRecommendationGetRequestParams({
      currentServiceId,
      experiment: pdpAvailableExperiment,
      isEligible: widgetId === RECOMMENDATION_WIDGET_PDP_AVAILABLE,
      isProdrecEnabledAndV2,
    })
    const sellerId = currentOffer?.seller?.sellerId ?? ''

    return {
      baseServiceId,
      pid: currentVariant.upid,
      ...experimentRequestParams,
      sellerid: sellerId,
      titlekey: language,
      widgetId,
    }
  }
